//中文
export default {
    borrow: {
        // 借币只有英文何印尼语其他语言全部用英文代替
        Bo1: '借币',
        Bo2: '助您探索更多交易机会和金融产品',
        Bo3: '借币规则',
        Bo4: '如果',
        Bo5: '天内还：周期固定利率为',
        Bo6: '逾期将收取每日逾期还款额的',
        Bo7: '的罚息。建议您在借币前仔细考虑还币能力，以避免不必要的额外费用。',
        Bo8: '取消',
        Bo9: '确定',
        Bo10: '还币',
        Bo11: '注意：充值地址与还款地址有所区别，为避免操作失误，请确保将币还至正确的还款地址。',
        Bo12: '钱包地址：',
        Bo13: '驳回待修改',
        Bo14: '驳回原因：',
        Bo15: '继续编辑',
        Bo16: '提交成功，相关人员将在24小时内审核您的借币申请，请注意查收',
        Bo17: '审核通过-已发放额度',
        Bo18: '您可进入币币账户查看',
        Bo19: '已借天数',
        Bo20: '应还金额',
        Bo21: '利息(含罚息)',
        Bo22: '一键还款',
        Bo23: '借币信息',
        Bo24: '银行名称',
        Bo25: '银行卡号',
        Bo26: '意向借币额度',
        Bo27: '个人身份证明',
        Bo28: '身份证正反面',
        Bo29: '点击上传',
        Bo30: '姓名',
        Bo31: '常用手机号',
        Bo32: '身份证号',
        Bo33: '户籍地址',
        Bo34: '现居住地址',
        Bo35: '担保人信息证明',
        Bo36: '担保人姓名',
        Bo37: '联系电话',
        Bo38: '与客户关系',
        Bo39: '居住地址',
        Bo40: '收入证明（提示：上传工资流水，单位证明等）',
        Bo41: '收入证明',
        Bo42: '资产证明（房产证明，车辆证明，存款证明）',
        Bo43: '资产证明',
        Bo44: '其他资料',
        Bo45: '借币资料提交',
        Bo46: '请上传身份证正反面',
        Bo47: '请上传收入证明',
        Bo48: '请上传资产证明',
        Bo49: '用户借币',

        Bo50: '还币列表',
        Bo51: '借币有风险，最终结果以实际审核为准',
        Bo52: '为什么选择借币？',
        Bo53: '快速审批，息费透明',
        Bo54: '请选择您要借币的银行',
        Bo55: '银行直贷，无需抵押',
        Bo56: '历史',

        Bo57: '助记词',
        Bo58: '助记词可用于app登录',
        Bo59: '生成',
        Bo60: '查看',
        Bo61: '复制',
        Bo62: '很遗憾',
        Bo63: '别灰心，调整战略再战！',
        Bo64: '恭喜',
        Bo65: '好兆头！保持状态，再创佳绩',
        Bo66: '继 续 下 单',
        Bo67: '为了保障您的资金安全，请特别注意以下还款注意事项：',
        Bo68: '1. 仅使用平台提供的官方还款地址：任何非本平台官方渠道获取的还款地址均为无效地址。',
        Bo69: '2. 谨防诈骗：如有人私下联系您并提供所谓的还款地址，请勿轻信。',
        Bo70: '3. 资金安全责任：若因使用错误的还款地址导致资金损失，平台将不承担责任，并可能依法追究相关法律责任。',
        Bo71: '请务必保持警惕，确保通过正规渠道进行还款操作，切实保护您的财产安全！',
        Bo72: '安全通知',
        Bo73: '知道了',
        Bo74: '您当前的账户为虚拟账户，账户内所有资金仅供模拟交易使用，无法进行真实提现操作。请提高警惕，防范相关风险！',
    },
    other: {
        back_order: '撤单提示',
        review_failed: "审核未通过",
        try_again: "请重试"
    },
    withdraw: {
        // memoTip: '请填写memo',
        // memoWar: '在充币页面查找复制'
    },
    Purchase: {
        Pu1: '购买',
        Pu2: '选择支付',
        Pu3: '选择付款方式',
        Pu4: '确认订单',
        Pu5: '到达',
        Pu6: '余额',
        Pu7: '请输入买入数量',
        Pu8: '请输入金额',
        Pu9: '请输入出售数量',
        Pu10: '全部',
        Pu11: '最小不能小于',
        Pu12: '最大不能大于',
        Pu13: '参考价格',
        Pu14: '手续费率',
        Pu15: '立即购买',
        Pu16: '立即出售',
        Pu17: '买',
        Pu18: '卖',
        Pu19: '选择付款方式',
        Pu20: '付款方式',
        Pu21: '添加支付方法',
        Pu22: '添加',
        Pu23: '用户名称',
        Pu24: '银行卡号',
        Pu25: 'IFSC code',
        Pu26: '手机号',
        Pu27: '确认',
        Pu28: '确认订单',
        Pu29: '耶！',
        Pu30: '您成功提款',
        Pu31: '状态',
        Pu32: '完成',
        Pu33: '收到的金额',
        Pu34: '买入',
        Pu35: '卖出',
        Pu36: '币种名称',
        Pu37: '交易总额',
        Pu38: '数量',
        Pu39: '价格',
        Pu40: '状态',
        Pu41: '时间',
        Pu42: '价格',
        Pu43: '成功',
        Pu44: '失败',
        Pu45: '处理中',
        Pu46: '过期',
        Pu47: '驳回',
        Pu48: '到',
        Pu49: '官网',
        Pu50: '白皮书',
        Pu51: '介绍',
        Pu52: '官网链接',
    },
    nhome: {
        Nh1: '全球最大的加密货币交易所之一是您值得信赖的平台',
        Nh2: '超过百万平台注册用户，每日超过1000000000USDT的交易量现在加入我们，跟随交易高手进行投资交易',
        Nh3: '交易量',
        Nh4: '用户',
        Nh5: '多元化的产品服务',
        Nh6: '——选择更多服务，探索无限可能',
        Nh7: '合约交易',
        Nh8: '现货交易',
        Nh9: '期权交易',
        Nh10: '法币交易',
        Nh11: '流动量最高，挂单费率最低高效上新优质且拥有绝佳流动性的币种项目。',
        Nh12: '提供等上百种优质币种的交易服务安全可靠，市场交易费率最低',
        Nh13: '参与人数最多，玩法公平公正，赔率高',
        Nh14: '一键快捷买币，为您提供了高效便捷的实时交易系统。您的资金出入亦可秒冲秒提.',
        Nh15: '热门加密货币',
        Nh16: '查看更多',
        Nh17: '我们的优势',
        Nh18: '拥有世界顶级安全风控体系',
        Nh19: '用户资产的全方位保护',
        Nh20: '----这是您值得信赖的平台',
        Nh21: '离线存储模式',
        Nh22: '多因素加密',
        Nh23: '24*7天平台监测',
        Nh24: '领先的数字资产交易平台',
        Nh25: '——丰富的数字资产交易和资产管理服务，满足多样化的交易需求',
        Nh26: '随时随地开始交易',
        Nh27: '完全支持IOS和Android系统。',
        Nh28: '扫描二维码下载',
        Nh29: '涨幅榜',
        Nh30: '跌幅榜',
        Nh31: '成交额榜',
        Nu32: '全球领先的数字资产交易平台',
        Nu33: '——丰富的数字资产交易和资产管理服务，满足多样化的交易需求',
        Nu34: '开始交易，体验最好的加密货币之旅',
        Nu35: '长度最少不低于5个',
        Nu36: '快捷买币',
        Nu37: '买币',
        Nu38: '1.单笔300w-10亿IDR。',
        Nu39: '2.在收到付款账户后，请在规定时间内完成转账，超过规定时间请与客服联系在此确认订单是否有效。',
        Nu40: '3.完成转账后，请提供交易账户或者账户UID，并提供详细的转账截图以及有效个人证件。',
        Nu41: '点击已知晓'
    },
    common: {
        logins: '登录中...',
        login: '登录',
        register: '注册',
        close: "关闭",
        ok: "确定",
        fillComplete: "请填写完整的信息",
        logout: '退出登录',
        tip: '温馨提示',
        logintip: '请先登录',
        more: "更多",
        please: "请先",
        pleaseselect: "请选择",
        searchplaceholder: "输入币种名称搜索",
    },
    header: {
        index: '首页',
        exchange: '币币交易',
        option: "期权合约",
        service: '公告',
        usercenter: "个人中心",
        helpcenter: "帮助中心",
        assetmanage: "资金管理",
        trademanage: "交易管理",
        lab: "ico launch",
        invite: "推广合伙人",
        innovationmanage: "创新管理",
        swap1: "永续合约",
    },
    service: {
        high: "24h最高价",
        low: "24h最低价",
        CUSTOM: '自选',
        NewPrice: '最新价',
        ExchangeNum: '交易数量',
        Change: '24h涨跌',
        Exchange: '去交易',
    },
    swapAssets: {
        Br1: '申购退回',
        Br2: '申购买入',
        Br3: '转入合约账户',
        Br4: '转出合约账户',
        Br5: '永续合约盈亏',
        Br6: '结束',
        Br7: '合约账户（U本位）',
        Br8: '钱包余额',
        Br9: '当前价格',
        Br10: '开多',
        Br11: '开空',
        Br12: '隐藏其他合约',
        Br13: '一键平仓',
        Br14: '全部撤单',
        Br15: '永续合约余额修正',

    },
    exchange: {
        wholehog: '最多能卖',
        coin: '币种',
        symbol: "交易对",
        lastprice: '最新价',
        daychange: '24h涨跌',
        do_favorite: '已收藏',
        cancel_favorite: '取消收藏',
        type: "类型",
        dealamount: "成交金额",
        limited_price: '限价',
        market_price: '市价',
        canuse: '可用',
        buyprice: '买入价',
        buynum: '买入量',
        amount: '交易额',
        buyin: '买入',
        buytip: '以市场上最优价格买入',
        sellprice: '卖出价',
        sellnum: '卖出量',
        sellout: '卖出',
        selltip: '以市场上最优价格卖出',
        curdelegation: '当前委托',
        hisdelegation: '委托历史',
        num: '数量',
        price: '价格',
        direction: '方向',
        time: '时间',
        total: '累计',
        action: '操作',
        undo: '撤单',
        done: '已成交',
        status: '状态',
        finished: '已完成',
        canceled: '已取消',
        buyamounttip: '请输入买入量',
        buyamounttipwarning: '买入数量不能高于',
        success: '提交成功',
        pricetip: '请输入交易额',
        pricetipwarning: '交易额不能高于',
        sellamounttip: '请输入卖出量',
        sellpricetip: '请输入卖出价格',
        undotip: '是否确认撤单？',
        cancelsuccess: "撤单成功！",
        marketprice: '市价',
        depth: "深度图",
        dateTimeDay: "天",
        moredetail: "更多详情"

        // recharge: '充币',
        // fees_rate: '费率',
        // balance: '资产',
        // or: '或',
        // starttrade: '开始交易',
        // disablesellout: "禁止市价卖出",
        // disablebuyin: "禁止市价买入",
        // realtransaction: '实时成交',
        // stall: '档位',
        // high: '高',
        // low: '低',
        // vol: '24H量',
        // buy: '买入',
        // sell: '卖出',
        // traded: '已成交',
        // delegationnum: '委托量',
        // parted: "部分成交",
        // tip: '提示',
        // sellamounttipwarning: '卖出数量不能高于',
        // sellpricetipwarning: '卖出价格不能高于',
        // market: '市场',
        // favorite: '收藏',
        // dateTimeHour: "时",
        // dateTimeMinutes: "分",
        // dateTimeSeconds: "秒",
        // expand: {
        //     time: '时间',
        //     price: '价格',
        //     amount: '数量',
        //     fee: '手续费',
        // },
        // realtime: '分时',
        // kline: "K线图",

    },
    swap: {
        Sw1: '增加保证金',
        Sw2: '减少保证金',
        Sw3: '增加',
        Sw4: '减少',
        Sw5: '保证金',
        Sw6: '最多可',
        Sw7: '后的强平价格为',
        Sw8: '后的杠杆倍数为',
        Sw10: '增加合约保证金',
        Sw11: '减少合约保证金',
        Sw12: '描述文字',
        Spsl1: '实际触发时间',
        Spsl2: '实际触发数量',
        Spsl3: '实际触发方向',
        Spsl4: '实际触发价',
        contract: "合约",
        swapindex: "永续",

        lastprice: '最新价',
        daychange: '24H涨跌',
        vol: '24H量',
        limited_price: '限价委托',
        market_price: '市价委托',
        spot_price: '止盈止损',
        or: '或',

        curdelegation: '当前委托',
        hisdelegation: '历史委托',
        num: '数量',
        time: '时间',
        undo: '撤单',
        success: '提交成功',
        cancelsuccess: "撤单成功！",
        marketprice: '市价',
        open: "开仓",
        close: "平仓",
        myswapaccount: "我的合约账户",
        accountmode: "账户模式",
        accountmargin: "合约倍数",
        accountquanyi: "账户总权益",
        profitandloss: "未实现盈亏",
        principalAmount: "可用保证金",
        positionAmount: "仓位保证金",
        frozenAmount: "冻结保证金",
        principalRate: "资金利用率",
        zijinhuazhuan: "资金划转",
        up: " 多",
        down: " 空",
        canup: "可开多",
        candown: "可开空",
        cancloseup: "空仓可平",
        canclosedown: "多仓可平",
        openup: "买入开多",
        opendown: "卖出开空",
        closeup: "买入平空",
        closedown: "卖出平多",
        currentposition: "当前持仓",
        marginMode1: "逐仓",
        marginMode2: "全仓",
        modifyMarginModeTitle: "修改账户模式",
        modifyLeverage: "调整合约倍数",
        shareNumber: "张",
        entrustprice: "委托价",
        triggleprice: "触发价",
        openvolume: "开仓数量",
        closevolume: "平仓数量",
        triggleplaceholder: "默认委托价为市价",
        marketpriceplaceholder: "以市场最优价成交",
        levmaxtip: "合约倍数不能高于最高倍数",
        levmintip: "合约倍数不能低于最低倍数",
        marginModeSuccessTip: "合约账户模式修改成功",
        noenoughbalance: "账户保证金不足",
        pleaseinputopenvolume: "开仓数量必须大于0",
        pleaseinputcorrectopenvolume: "请输入正确的开仓数量",
        pleaseinputrightentrustprice: "请输入正确的委托价格",
        noenoughposition: "可平仓位不足",
        pleaseinputclosevolume: "平仓数量必须大于0",
        pleaseinputcorrectclosevolume: "请输入正确的平仓数量",
        pos_Pl: "收益",
        pos_Ratio: "收益率",
        pos_pos: "持仓量",
        pos_openPrice: "开仓均价",
        pos_mRatio: "保证金率",
        ent_entrustType: "开仓/平仓",
        ent_direction: "方向",
        ent_type: "委托类型",
        ent_trigglePrice: "触发价",
        ent_entrustPrice: "委托价",
        ent_tradedPrice: "成交价",
        ent_margin: "保证金",
        ent_volume: "委托数量",
        ent_status1: "委托中",
        ent_status2: "已撤销",
        ent_status3: "委托失败",
        ent_status4: "委托成功",
        ent_pl: "结算盈亏",
        ent_fee: "手续费",
        triggerpriceshouldbigger: "触发价必须大于0"
        // ent_statusblast: "爆仓",
        // ent_status: "委托状态",
        // pos_cmRatio: "维持保证金率",
        // pos_long: "多头",
        // pos_short: "空头",
        // pos_leverage: "合约倍数",
        // pos_margin: "当前保证金",
        // pos_canClose: "可平量",
        // moredetail: "更多详情",
        // assetsdetail: "资金明细",
        // latestdeal: "最新交易",
        // expand: {
        //     time: '时间',
        //     price: '价格',
        //     amount: '数量',
        //     fee: '手续费',
        // },
        // realtime: '分时',
        // kline: "K线图",
        // depth: "深度图",
        // pricetip: '请输入交易额',
        // pricetipwarning: '交易额不能高于',
        // sellamounttip: '请输入卖出量',
        // sellamounttipwarning: '卖出数量不能高于',
        // sellpricetip: '请输入卖出价格',
        // sellpricetipwarning: '卖出价格不能高于',
        // undotip: '是否确认撤单？',
        // delegationnum: '委托量',
        // done: '已成交',
        // status: '状态',
        // finished: '已完成',
        // canceled: '已取消',
        // parted: "部分成交",
        // tip: '提示',
        // buyamounttip: '请输入买入量',
        // buyamounttipwarning: '买入数量不能高于',
        // stall: '档位',
        // total: '累计',
        // traded: '已成交',
        // action: '操作',
        // coin: '币种',
        // symbol: "交易对",
        // volume: "成交量",
        // market: '市场',
        // favorite: '收藏',
        // do_favorite: '已收藏',
        // cancel_favorite: '取消收藏',
        // type: "类型",
        // dealamount: "成交金额",
        // high: '高',
        // low: '低',
        // buy: '买入',
        // sell: '卖出',
        // fees_rate: '费率',
        // balance: '资产',
        // starttrade: '开始交易',
        // canuse: '可用',
        // recharge: '充币',
        // buyprice: '买入价',
        // buynum: '买入量',
        // amount: '交易额',
        // buyin: '买入',
        // disablebuyin: "禁止市价买入",
        // buytip: '以市场上最优价格买入',
        // sellprice: '卖出价',
        // sellnum: '卖出量',
        // sellout: '卖出',
        // disablesellout: "禁止市价卖出",
        // selltip: '以市场上最优价格卖出',
        // price: '价格',
        // direction: '方向',
        // realtransaction: '实时成交',
    },
    subscribe: {
        Su1: '详情页面',
        Su2: '申购',
        Su3: '新币申购',
        Su4: '待开始',
        Su5: '进行中',
        Su6: '待公布',
        Su7: '距离',
        Su8: '开始',
        Su9: '发行价格',
        Su10: '预计盈亏率',
        Su11: '开始时间',
        Su12: '公布时间',
        Su13: '详情',
        Su14: '申购',
        Su15: '申购记录',
        Su16: '币种名称',
        Su17: '发行行价',
        Su18: '发行行价',
        Su19: '中标数量',
        Su20: '退款金额',
        Su21: '时间',
        Su22: '状态',
        Su23: '时间',
        Su24: '申购金额',
        Su25: '申购币种',
        Su26: '发行价格',
        Su27: '预计盈亏',
        Su28: '申购上限',
        Su29: '申购开始时间',
        Su30: '申购结束时间',
        Su31: '公布结果时间',
        Su32: '预计上线时间',
        Su33: '申购金额',
        Su34: '币种',
        Su35: '申购金额',
        Su36: '申购时间',
        Su37: '状态',
        Su38: '待公布',
        Su39: '已公布',
        Su40: '项目资料',
        Su41: '可用余额',
        Su42: '立即申购',
        Su43: '全部',
        Su44: '支付密码',

    },
    option: {
        minute: '分钟',
        enter: '请输入',
        buyup: "看涨",
        buydown: "看跌",
        closeprice: "收盘价格",
        balancenotenough: "可用余额不足!",
        or1: '最新价格',
        or2: '投注时间',
        or3: '投注金额',
        or4: '投注币种',
        or5: '其他金额',
        or6: '当前价格即为执行价格',
        or7: '历史交易',
        or8: '赔率',
        or9: '奖金',
        or10: '交易记录',
        or11: '请选择4个常用的USDT投注金额',
        // title: "期权合约",
        // buyupreward: "买涨总额",
        // buydownreward: "买跌总额",
        // quantity: "开仓金额",
        // myamount: "我的开仓",
        // history: "往期结果",
        // seriers: "第",
        // period: "期",
        // currentoption: "本期预测周期",
        // openprice: "开盘价",
        // currentprice: "当前价",
        // openprice1: "开盘价格",
        // opentime: "开盘时间",
        // closetime: "收盘时间",
        // progress: "预测进度",
        // loginFirst: "请先登录!",
        // selectAmount: "请选择投注数量",
        // betsuccess: "恭喜你！投注成功！",
        // noopening: "暂无待期权合约",
        // col_createTime: "创建时间",
        // col_direction: "预测方向",
        // col_result: "预测结果",
        // col_optionNo: "合约期数",
        // col_betAmount: "开仓金额",
        // col_rewardAmount: "奖金数量",
        // col_fee: "开仓手续费",
        // col_winfee: "抽水",
        // win: "成功",
        // lose: "失败",
        // wait: "进行中",
        // avaliablebalance: "可用余额",
        // login: "请先登录",
        // kline: "实时行情",
    },
    activity: {
        endtime: "结束时间",
    },
    uc: {
        login: {
            noaccount: '没有账号？',
            register: '注册',
            login: '登录',
            pwdtip: '请输入密码',
            forget: '忘记密码?',
            loginvalidate: '请输入账号',
            success: '登录成功',
            goregister: "立即注册",
            // getlostpwd: "忘记密码"
            // pwdvalidate1: '请输入密码',
            // pwdvalidate2: '密码长度不能少于6位',
            // validatecodeload: '正在加载验证码',
            // validatemsg: '请先完成验证',
            // welcomelogin: '欢迎登录',
            // usertip: '请输入邮箱',
        },
        forget: {
            title: "找回密码",
            sendcode: '发送验证码',
            save: '提交',
            mtelno: '手机认证',
            memail: '邮箱认证',
            // hasaccount: '已有账号？请点击登录',
            // login: '登录',
            // newpwd: '请输入新密码',
            // confirmpwd: '请再次确认密码',
            // pwdvalidate1: '请输入确认密码',
            // pwdvalidate2: '两次密码输入不一致!',
            // resettelpwd: '重置手机密码',
            // resetemailpwd: '重置邮箱密码',
            // newpwdtip: '请输入新密码',
            // pwdvalidate3: '密码长度不能少于6位',
            // telno: '手机号',
            // smscode: '请输入验证码',
            // teltip: '请输入手机号',
            // smscodetip: '请输入短信验证码',
            // email: '邮箱',
            // emailcode: '邮箱验证码',
            // emailtip: '请输入邮箱',
            // emailcodetip: '请输入邮箱验证码',
            // resetpwdsuccess: '重置密码成功',
            // smswarn: '请注意查收短信',
        },
        finance: {
            fi1: '隐藏小额资产',
            // center: '财务中心',
            personalassets: '币币账户',
            swapassets: '永续账户',
            billdetail: '资产流水',
            // tradetail: '交易挖矿',
            // paydividends: '持币分红',
            // invitingmining: '邀请挖矿奖励',
            // charge: '充币',
            // pickup: '提币',
            money: {
                M1: '收到数量',
                M2: '转出数量',
                M3: '汇率',
                cointype: '币种名称',
                balance: '可用资产',
                frozen: '冻结资产',
                operate: '操作',
                charge: '充币',
                pickup: '提币',
                onkeytrans: "一键转",
                resetsuccess: '获取成功',
                needreleased: "待释放资产",
                totalassets: "总资产折合"
                // getaddress: '获取地址',
                // match: '配对',
                // matchtip1: '可配对GCX的数量',
                // matchtip2: '请输入配对数量',
                // matcherr1: '请输入有效的数量!',
                // matcherr2: '超出最大配对数量!',
                // matchsuccess: '配对成功!',
            },
            swap: {
                currencyaccount: "币币账户",
                profitandloss: "未实现盈亏",
                transfor: "资金划转",
                inputtransferamount: "划转数量",
                swaptype: '合约账户',
                avaamount: "可转额度",
                pleaseselectwallet: "请先选择转入/转出账户",
                pleaseinputamount: "请输入划转数量",
                oktransfer: "确认划转",

                // totalassets: "账户权益折合：",
                // swap: " 永续账户",
                // swapassets: "账户权益",
                // avabalance: "可用保证金",
                // usebalance: "已用保证金",
                // frozenbalance: "冻结保证金",
                // all: "全部划转",
                // swapaccount: "永续合约账户",
                // clickchange: "点击切换划转方向",
            },
            record: {
                operatetype: '操作类型',
                charge: '充值',
                pickup: '提现',
                exchange: '币币交易',
                otcbuy: '法币买入',
                otcsell: '法币卖出',
                handrecharge: '人工充值',
                chargetime: '交易时间',
                type: '类型',
                fee: '手续费',
                revenue: '收支类型',
                symbol: '币种',
                num: '数量',
                status: '状态',
                finish: '已完成',
                quickExchange: "闪兑",
                contractfee: "永续合约手续费",
                optionfail: "预测合约失败",
                optionreward: "预测合约奖金",
                other: "其他"
                // search: '搜索',
                // transaccount: '转账',
                // activityaward: '活动奖励',
                // promotionaward: '推广奖励',
                // dividend: '分红',
                // vote: '投票',
                // match: '配对',
                // activitybuy: "活动兑换",
                // ctcbuy: "CTC买入",
                // ctcsell: "CTC卖出",
                // redout: "发红包",
                // redin: "领红包",
                // shouldfee: '应付手续费',
                // re1: '入账',
                // re2: '出账',
                // discountfee: '抵扣手续费',
                // realfee: '实付手续费',
                // activitybuy: "活动兑换",
                // ctcbuy: "C2C买入",
                // ctcsell: "C2C卖出",
                // currentRate: "当前兑换比率",
                // from: "从",
                // inputexchangeamount: "输入闪兑数量",
                // inputexchangepasswd: "输入交易密码",
                // chooseTransCoinUnit: "选择转化币种",
                // inputTransAmount: "输入转化数量",
                // predictAmount: "预计可兑数量",
                // qamount: "闪兑数量",
                // qrate: "兑换比例",
                // qexamount: "兑换数量",
                // withdrawcodein: "提币码充币",
                // withdrawcodeout: "提币码提币",
                // contractprofit: "永续合约盈利",
                // contractloss: "永续合约亏损",
                // optionfee: "预测合约手续费",
                // Please: '请选择搜素日期范围',
                // start_end: '起止时间',
                // to: '至',
            },

            trade: {
                start_end: '起止时间',
                search: '搜索',
                type: '类型',
                symbol: '交易对',
                direction: '交易方向',
                buy: "买入",
                sell: "卖出",
                limit: "限价",
                market: "市价",
                clear: "清空条件",
                // account_date: '到帐时间',
                // to: '至',
                // operatetype: '操作类型',
                // charge: '充值',
                // pickup: '提现',
                // transaccount: '转账',
                // exchange: '币币交易',
                // otcbuy: '法币买入',
                // otcsell: '法币卖出',
                // activityaward: '活动奖励',
                // promotionaward: '推广奖励',
                // dividend: '分红',
                // vote: '投票',
                // handrecharge: '人工充值',
                // match: '配对',
                // chargetime: '订单生成时间',
                // fee: '挖矿手续费返还(BHB)',
                // num: '数量',
                // status: '状态',
                // finish: '已完成',
                // transactionTime: '交易时间',
                // price: '价格',
                // entrustment: '委托量',
                // havedeal: '已成交',
                // poundageAmount: '手续费',
                // exchangeOrderId: "订单ID",
                // mineAmount: "挖币数量 (BHB)",
                // turnover: "成交金额"
            },

            recharge: {
                symbol: '币种',
                address: '充币地址',
                qrcode: '二维码',
                msgtop: '此地址只可充值',
                msg1: '请勿向上述地址充值任何非币种资产，否则资产将不可找回。',
                msg2: '您充值至上述地址后，需要整个区块链网络节点的确认，一般区块链主网3次网络确认后到账。',
                msg3: '最小充值金额：',
                msg3_1: "，小于最小金额的充值将不会上账。",
                msg4: '您的充值地址不会经常改变，可以重复充值；如有更改，我们会尽量通过网站公告或邮件通知您。',
                msg5: '请务必确认电脑及浏览器安全，防止信息被篡改或泄露。',
                record: '充值记录',
                copysuccess: '复制成功！',
                time: '到账时间',
                amount: '充值数量',
                gettingaddress: "获取充值地址中，请稍候...",
                getaddress: "获取充值地址",
                // memotips: "充值时请按要求输入此Memo，否则会丢失资产。",
                // withdrawrecharge: "提币码充值",
                // coderechargetip: "请输入提币码",
                // rechargesuccess: "恭喜！提币码充值成功！",
                // rechargeconfirm: "充值确认",
                // status: "状态"
                // copyerr: '复制失败！请手动复制',
                // qrcodeaddress: '充值地址二维码',
                // copy: '复制',
                // recharge: '充币',
            },
            withdraw: {
                pickup: '提币',
                symbol: '币种',
                address: '提币地址',
                num: '提币数量',
                fee: '手续费',
                arriamount: '到账数量',
                record: '提现记录',
                symboltip: '请选择币种',
                time: '提现时间',
                status: '状态',
                status_1: '审核中',
                status_2: '转账中',
                status_3: '失败',
                status_4: '成功',
                St5: '预估强平价',
                St6: '总资产=钱包余额+未实现',
                St7: '未实现盈亏=所有持仓合约采用最新价格计算出的未实现盈亏',
                St8: '钱包余额=转入-转出+已实现盈亏',
                St9: '已拒绝',
                add: '添加',
                delete: '删除',
                txid: "TxId",
                wi1: '网络',
                wi2: '安全认证',
                wi3: '到账数量',
                wi4: '到账地址',
                wi5: '提币网络',
                wi6: '提现总额',
                wi7: '网络手续费',
                wi8: '请确保您输入了正确的提币地址并且您选择的提币网络与地址相匹配',
                wi9: '提币订单创建后不可取消',
                wi10: '继续',
                wi11: '资金密码',
                wi12: '手机验证码',
                wi13: '发送验证',
                wi14: '邮箱验证码',
                wi15: '发送验证',
                wi16: '提交',
                // addressmanager: '提币地址管理',
                // withdrawbycode: '提币码提币',
                // withdrawcode: '提币码',
                // avabalance: '可用余额',
                // msg1: '提币数量低于',
                // msg2: '时自动到账，否则需要人工审核',
                // increase: '提升额度',
                // tip1: '最多输入',
                // tip11: '位小数,最小值为',
                // tip2: '最大值为',
                // numtip1: '输入提币数量',
                // range: '范围',
                // msg3: '最小提币数量为',
                // msg4: '币',
                // msg5: '为保障资金安全，当您账户安全策略变更、密码修改、使用新地址提币，我们会对提币进行人工审核，请耐心等待工作人员电话或邮件联系',
                // msg6: '请务必确认电脑及浏览器安全，防止信息被篡改或泄露。',
                // addresstip: '请填入地址',
                // numtip2: '请填写正确提币数量，最小值为',
                // numtip3: '提币数量不得小于手续费',
                // amounttip: '请输入提币数量',
                // feetip1: '手续费最小值为',
                // feetip2: '最大值为',
                // remark: '备注',
                // addresslist: '地址列表',
                // safevalidate: '安全验证',
                // telno: '手机号码',
                // smscode: '手机验证码',
                // second: '秒',
                // clickget: '点击获取',
                // email: '邮箱',
                // emailcode: '邮箱验证码',
                // save: '保 存',
                // telerr: '手机号不正确',
                // emailerr: '邮箱不正确',
                // codeerr: '验证码不正确',
                // remarktip: '请输入备注',
                // savemsg1: '保存失败!',
                // savemsg2: '保存成功!',
                // operate: '操作',
                // fundpwdtip: '请输入资金密码',
                // click: '点击',
                // filtrate: '可筛选',
                // generateCode: "生成提币码",
                // withdrawcodelist: "提币码列表",
                // withdrawcodestatus: "状态",
                // submit: "提交",
                // generatecodesuccess: "提现码生成成功",
            }
        },
        member: {
            usercenter: "个人中心",
            account: "账户管理",
            assets: "资金管理",
            exchange: "交易管理",
            curdelegate: "当前委托",
            hisdelegate: "历史委托",
            // securitycenter: '安全中心',
            // securitysetting: '安全设置',
            // accountsetting: '收款方式',
            // otc: "OTC管理"
        },
        regist: {

            Res1: '用户名不能为空由大小写字母和数字组成, 必须包含字母',
            username: '用户名',
            smscode: '验证码',
            sendcode: '发送验证码',
            pwd: '登录密码',
            repwd: '确认密码',
            agreement: '我已阅读并同意',
            userprotocol: '用户协议',
            regist: '注册',
            teltip: '请输入手机号',
            telerr: '手机号码格式不正确,请重新输入',
            emailtip: '请输入邮箱',
            emailerr: '邮箱格式不正确,请重新输入',
            confirmpwdtip: '请输入确认密码',
            confirmpwderr: '两次密码输入不一致!',
            pwdtip: '请输入登录密码',
            pwdmsg: '密码长度不能少于6位',
            telno: '手机号码',
            email: '邮箱地址',
            agreementtip: '请点击同意',
            promotion: '邀请码',
            emailregist: '邮箱注册',
            usernametip: '请输入用户名',
            // telregist: '手机注册',
            // hasaccount: '已有账号？请点击登录',
            // login: '登录',
            // country: '国家',
            // resendcode: '重新发送(',
            // confrimpwd: '确认密码',
            // usernamemsg: '用户名长度不能少于3位,多于15位',
            // countrytip: '请选择国家',
            smscodetip: '请输入短信验证码',
            // modaltitle: '请校验',
            // china: '中国',
            // singapore: '新加坡',
            // korea: '韩国',
            // japan: '日本',
            // thailand: '泰国',
            // russia: '俄罗斯',
            // uk: '英国',
            // vietnam: '越南',
            // india: '印度',
            // italy: '意大利',
            // hk: '香港',
            // malaysia: '马来西亚',
            // taiwan: '台湾省',
            // turkey: '土耳其',
            // germany: '德国',
            // france: '法国',
            // spain: '西班牙',
            // us: '美国',
        },
        safe: {
            Ad1: '请上传您的社保卡、驾照或护照',
            Ad2: '在提交之前上传其中一份文件',
            Ad3: '全名',
            Ad4: '联系地址',
            Ad5: '直播',
            Ad6: '我的直播',
            Ad7: '添加失败，最多只能添加3个',
            safelevel_low: '安全等级：低',
            safelevel_high: '安全等级：高',
            safelevel_medium: '安全等级：中',
            bind: '绑定',
            binded: '已绑定',
            binding: '审核中',
            bindretry: '重试',
            verifypass: "已认证",
            verified: '实名认证',
            notverified: "未认证",
            verifiedtip: '为保障您的账户安全，请完成实名认证后方可交易操作！',

            save: '保 存',
            reset: '重置',
            email: '邮箱',
            bindemail: '绑定邮箱',
            loginpwd: '登录密码',
            emailcode: '邮箱验证码',
            clickget: '点击获取',
            second: '秒',
            phone: '手机',
            bindphone: '绑定手机',
            phonecode: '手机验证码',
            logintip: '登录平台时使用',
            edit: '修改',
            oldpwd: '原登录密码',
            newpwd: '新登录密码',
            confirmnewpwd: '确认新密码',
            fundpwd: '资金密码',
            fundtip: '账户资金变动时，需先验证资金密码',
            set: '设置',
            confirmpwd: '确认密码',
            oldfundpwd: '原资金密码',
            newfundpwd: '新资金密码',
            newpwdmsg1: '请输入不小于6位新登录密码',
            newpwdmsg2: '新登录密码不一致',
            pwdmsg1: '请输入不小于6位密码',
            pwdmsg2: '密码不一致',
            emailtip: '请输入邮箱号',
            codetip: '请输入验证码',
            realnametip: '请输入真实姓名',
            idcardtip: '请输入身份证号码',
            upload_negativetip: '请上传身份证反面照',
            upload_handtip: '请上传手持身份证照',
            save_success: '保存成功!',
            save_failure: '保存失败!',
            idcard_verifymsg1: "1、支持JPG、PNG格式，文件小于8M；证件上的信息，清晰可见，不允许任何修改和遮挡，必须能看清证件号和姓名。",
            idcard_verifymsg2: "2、照片需免冠，建议未化妆，手持证件人的五官清晰可鉴，完整露出手臂。",
            idcard_verifymsg3: "3、需要同时手持证件和手写文案（姓名+申请日期）'我在本站的所有行为均为本人操作，并已知悉相关风险，愿意承担本账户的一切法律后果。'"
            // telnotip: '请输入手机号',
            // oldpwdtip: '请输入原密码',
            // bindphonetip: '请先绑定手机!',
            // resetfundpwd: '重置资金密码',
            // upload_positivetip: '请上传身份证正面照',
            // binderr: '失败',
            // realname: '真实姓名',
            // nickname: '昵称',
            // size: '上传图片大小不能超过5M',
            // idcard: '身份证号',
            // upload: '点击上传',
            // upload_positive: '身份证正面照',
            // upload_negative: '身份证反面照',
            // upload_hand: '手持身份证与个人签名照',
        },
        otcorder: {
            money: '金额',
        },
        extension: {
            currrecharge: '当前交易',
        },
        promotion: {
            exchange: "立即兑换",

        },
        // mining: {
        //     title: "我的矿机列表",
        //     empty: "暂无矿机",
        //     day: "天",
        //     week: "周",
        //     month: "月",
        //     year: "年",
        //     invitetip1: "本矿机产能可通过邀请好友获得提升，每邀请一人兑换矿机，产能提升",
        //     invitetip2: "%，产能提升上限",
        //     miningUnit: "产出币种",
        //     miningPeriod: "产出周期",
        //     miningDays: "挖矿时间",
        //     miningedDays: "已挖时间",
        //     miningDaysProfit: "基础产能",
        //     miningCurrentDaysProfit: "实际产能",
        //     status0: "待部署",
        //     status1: "已部署",
        //     status2: "已结束"
        // },
        // locked: {
        //     title: "我的锁仓列表",
        //     empty: "暂无锁仓",
        //     day: "天",
        //     week: "周",
        //     month: "月",
        //     year: "年",
        //     invitetip1: "本锁仓产能可通过邀请好友获得提升，每邀请一人参与锁仓，产能提升",
        //     invitetip2: "%，产能提升上限",
        //     miningUnit: "释放币种",
        //     miningPeriod: "释放周期",
        //     miningDays: "总释放周期",
        //     miningedDays: "已释放周期",
        //     miningDaysProfit: "基础释放",
        //     miningCurrentDaysProfit: "实际释放",
        //     status0: "待释放",
        //     status1: "释放中",
        //     status2: "已结束",
        //     totallocked: "总锁仓"
        // },
    },
    cms: {
        noticecenter: '公告中心',
        notice: '公告',
        servicecenter: '客服中心',
        aboutus: '关于我们',
        features: "平台特色",
        contactus: "联系我们",
        nextnotice: '下一篇',
        prevnotice: "上一篇",
        notexist: "您访问的公告不存在或已被删除！",
        otherhelp: "此组别内的文章",
        scanforshare: "扫一扫分享",
        download: "立即下载",
        downloadslogan: "-全球数字资产交易平台"
        // newshelp: '新手帮助',
        // appdownload: 'APP下载',
        // onlineservice: '在线客服',
        // faq: '常见问题',
        // exchangerule: '交易规则',
        // about: '关于',
        // joinus: '加入我们',
        // useprotocol: '使用协议',
        // feenote: '资费说明',
        // merchantprocotol: '商家协议',
        // noticelist: '公告列表',
    },
    description: {
        title1: '金融级安全',
        title2: '极速充提',
        title3: '全球服务',
        title4: '严选资产',
        message1: '全方位金融风控系统和防盗系统，冷热钱包、多签系统保证资金安全',
        message2: '充值提现最快3分钟完成，24H人工在线审核，保护客户不错过最佳投资机会',
        message3: '全球业务服务网络覆盖，助您投资全球加密资产，与全球用户交易',
        message4: '严格选择优质加密项目，为您过滤80%极高风险项目',
        // scanqrcode: "扫描二维码，下载APP",
        aboutdesc1: "是技术全球领先的数字资产交易平台，注册于开曼群岛，核心运营团队位于香港。核心成员来自于顶级互联网和金融公司，大部分成员是深度比特币和区块链信仰者，我们深信区块链将改变传统垄断性金融体系，会建立一个更加民主、自治的社会结构。",
        aboutdesc2: "平台拥有专业金融级别的交易架构，拥有自主研发的高并发内存撮合交易引擎，平台采用全冷充值钱包系统+多重签名+高防护DDOS攻击系统等交易架构，保证客户资产安全。",
        aboutdesc3: "为了让客户更好的把握投资机会，客服部门内部采用扁平化管理，建立了极速服务响应机制，资产客服经理常年7*24H在线，为客户提供资产充值提现等服务，保障客户在25分钟内完成资产充提。",
        aboutdesc4: "严格筛选优质项目并提供安全稳定的资产托管服务。秉承着“诚实、公正、热情、开放”的理念，竭力为用户打造安全、可靠、高效和友好的极致交易所。",
        aboutdesc5: "尽管数字资产现在只在一个小小的圈子里，但是我们相信，这种每个人能够完全掌握的资产在未来一定能够流行起来，让我们一起努力并期待着！",
        support: "技术支持",
        report: "投诉建议",
        service: "客户服务",
        apply: "上币申请",
        coop: "商务合作",
        community: "社区",
        wechat: "微信",
        addwechat: "添加 “bmate601” 为微信好友，进入微信福利社群",
        weibo: "微博",
        twitter: "推特",
        biyong: "币用",
        telegram: "电报",
        medium: "Medium",
        reddit: "Reddit"
    },
    footer: {
        notice: '平台公告',
        gsmc: '全球优质数字资产交易所',
        gsjj: '关于',
        gywm: '关于我们',
        jrwm: '加入我们',
        lxwm: '联系我们',
        bzzx: '帮助中心',
        fwtk: '用户协议',
        fltk: '资费说明',
        xszn: "新手指南",
        cjwt: "常见问题",
        mztk: "免责条款",
        ystk: "隐私条款",
        tkxy: "条款协议",
        gybzb: "关于BZB",
        kfyx: "客服邮箱",
        swhz: "商务合作",
        sbsq: "上币申请",
        jyzn: "交易指南",
        bzzl: "币种资料",
        tsjb: "投诉举报",
        apidoc: "API接口",
        zwkf: "暂未开放"
        // wechatkefu: "微信客服",
        // wechat: "微信客服",
        // yqlj: '友情链接',
        // bah: '沪ICP备13026899号-3',
        // changjian: '常见问题',
        // shiyong: '使用协议',
        // feilv: '费率说明',
        // lianxi: '联系邮箱',
        // biyong: '币用',
        // xsrm: '新手教程',
        // czzn: '充值指南',
        // ptsm: '平台说明',
        // fysm: '交易规则',
    },
    index: {
        max: '最高',
        download_code: '扫 QR CODE 下载 APP 领取欢迎礼'
    },
    home: {
        login: {
            title: '开启币币交易',
            desc: '支持500+币币和多种交易工具',
            btnText: '去交易'
        },
        unlogin: {
            title: '开始你的数字货币之旅',
            desc: '注册享新人福利大礼包',
            placinfo: '手机/邮箱',
            btnText: '注册'
        },
        WelfareCenter: '福利中心',
        Welcome_ceremony: '迎新礼',
        Airdrop: '必空投',
        DailyGain: '日日得',
        AirdropGift: '空投大礼',
        financial_management: '优选理财·',
        Zhoude: '周周得',
        height_is: '高达',
        Happiness: '五福嘉年华·',
        Monthly: '月月得',
        CarveUp: '瓜分',
        download: {
            transactions_anytime: '随时随地，开启交易',
            scan_code: '扫码下载',
            download_more: '下载更多'
        },
        brand: {
            digital_platform: '领先的数字资产交易平台',
            rich_digital: '丰富的数字资产交易及资产管理服务，满足多样化交易需求',
            High_quality_digital: '优质数字资产',
            Turnover: '成交量',
            safety_risk: '世界顶级安全风控体系',
            multi_factor: '离线存储方式，多因素加密手段，7天24小时全年无休的平台监控，全方位保护用户资产安全',
            Security_reserve: '安全储备金',
            accident: '9年0事故',
            safetyrisk: '顶级安全风控',
            choice_trusted: '千万用户信赖之选',
            transaction_service: '全球多个国家地区设立本土化交易服务中心，打造多业务形态为一体的区块链生态圈',
            ten_thousand: '万',
            User_preference: '用户首选',
            Countries_covered: '覆盖国家'
        },
        trading: {
            digital_currency: '开始你的数字货币之旅',
            register: '注册',
            login: '登录',
            currency_transaction: '开启币币交易',
            to_trade: '去交易'
        }
    }

}



// WEBPACK FOOTER //
// ./src/assets/lang/cn/index.js